/* tslint:disable */
/* eslint-disable */
export enum StamdataStatusEnum {
  Yes = 'Yes',
  Maybe = 'Maybe',
  No = 'No'
}
